import Slider from "react-slick";
import styles from "./ClientesCarousel.module.css";

// Lista estática simulando que están en /public/images/logos/
const logos = [
  "/images/logos/Empresa0.png",
  "/images/logos/Empresa1.png",
  "/images/logos/Empresa2.png",
  "/images/logos/Empresa3.png",
  "/images/logos/Empresa4.png",
  "/images/logos/Empresa5.png",
  "/images/logos/Empresa6.png",
  "/images/logos/Empresa7.png",
  "/images/logos/Empresa8.png",
  "/images/logos/Empresa9.png",
  "/images/logos/Empresa10.png",
  "/images/logos/Empresa11.png",
  "/images/logos/Empresa12.png",
  "/images/logos/Empresa13.png",
  "/images/logos/Empresa14.png",
  "/images/logos/Empresa15.png",
];
export default function ClientesCarousel() {
 const settings = {
  infinite: true,
  speed: 3000,              // velocidad total del bucle
  autoplay: true,
  autoplaySpeed: 0,         // 🔥 el truco: sin delay entre slides
  cssEase: "linear",        // 🔥 movimiento fluido
  slidesToShow: 5,
  slidesToScroll: 1,
  arrows: false,
  dots: false,
  pauseOnHover: false,      // no pausar al pasar el mouse
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        speed: 1500, 
      },
    },
  ],
};


  return (
    <div className={styles.carouselContainer}>
      <Slider {...settings}>
        {logos.map((logo, index) => (
          <div key={index} className={styles.logoSlide}>
            <img
              src={logo}
              alt={`Logo cliente ${index + 1}`}
              loading="lazy"
            />
          </div>
        ))}
      </Slider>
    </div>
  );
}
